import React, {Component} from 'react';
import {Link} from 'react-router'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as imagesActions from '../../../actions/image';
import DataTable from '../../../components/data-table/data-table';
import InternalImageV2 from '../../../components/internal-image-v2';

import LocalizedStrings from '../../../localization/strings';

class SeasonsContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
            page: 0
        };
    }
    fetch(params) {
        const fetchParams = {
            ...this.state,
            ...params
        }
        this.setState(fetchParams);
        this.props.actions.fetchImages(fetchParams.page, fetchParams.size);
    }
    componentWillMount() {
        this.props.actions.fetchImages();
    }
    removeItem(image) {
        if (confirm(LocalizedStrings.doYouWantToRemove)) {
            this.props.actions.deleteImage(image.id);
        }
        return false;

    }
    render() {
        const {items, total, page, loading, total_pages} = this.props.images;
        var config = {
            cols: [
                {

                    header: LocalizedStrings.image,
                    value: (item) => {
                        return <div className="image-display-in-table"><InternalImageV2 filename={item.filename} alt=""/></div>
                    }
                }, {

                    header: LocalizedStrings.url,
                    value: (item) => {
                        const url =  `${window.CARE_CONFIG.image_storage_base_url_v2}${item.filename}`;
                        return <a href={url} target="_blank">{url}</a>
                    }
                },{
                    value: (item) => {
                        return <div className="btn-group">
                            <a className="btn btn-red" onClick={this.removeItem.bind(this, item)}>{LocalizedStrings.delete}</a>
                        </div>
                    },
                    header: LocalizedStrings.actions
                }
            ]
        };
        return (
            <div>
                <h3>{LocalizedStrings.images}</h3>
                <div className="table-actions-row">
                    <Link to="/admin/images/new" className="btn btn-primary">
                        {LocalizedStrings.newImage}
                    </Link>
                </div>
                <div className="panel">
                    <div className="panel-body">
                        <DataTable config={config} items={items} page={page} total={total} loading={loading} totalPages={total_pages} loadAction={this.fetch.bind(this)}></DataTable>
                    </div>
                </div>
            </div>

        )
    }
}

export default connect(function(state) {
    return {images: state.images.images};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...imagesActions
        }, dispatch)
    };
})(SeasonsContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/image/images-container.js